import { ORGS, USERS } from "../data/staticData";

export const getOrgName = (orgId?: string): string =>
  ORGS.find(o => o.id === orgId)?.name ?? "—";

export const getUserName = (userId?: string): string =>
  USERS.find(u => u.id === userId)?.name ?? "—";

export const fmtDate = (iso?: string): string => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const uid = (): string => `id_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

export const clamp = (val: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, val));
